import http from 'utils/http';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { OrganizationPackageResponse, PackageResponse } from './types';
import { getAgencyPlanUrl, getBusinessPlansUrl, getBusinessPlanUrl } from './apiUrls';

export function getBusinessPlans(params?: Record<string, any>): Promise<{
  data: PackageResponse[];
  meta: MetaApiResponse;
}> {
  return http.get(getBusinessPlansUrl(), params);
}

export function getBusinessPlan(id: string): Promise<PackageResponse> {
  return http.get(getBusinessPlanUrl(id));
}

export function updateBusinessPlan(id: string, payload: any): Promise<any> {
  return http.put(getBusinessPlanUrl(id), payload);
}

export function createBusinessPlan(payload: any): Promise<any> {
  return http.post(getBusinessPlansUrl(), payload);
}

export function deleteBusinessPlan(id: string): Promise<String> {
  return http.delete(getBusinessPlanUrl(id));
}

export function getAgencyPlan(id: number): Promise<OrganizationPackageResponse> {
  return http.get(getAgencyPlanUrl(id));
}
